import { del, objectToQueryParams } from '@si/utils';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { queryKeys } from './queryKeys';

interface Params {
  projectId: string;
  filepath: string;
}

export function useDeleteProjectFile() {
  const queryClient = useQueryClient();

  const { mutate, error, isPending, isSuccess, reset } = useMutation({
    mutationFn: ({ projectId, filepath }: Params) =>
      del({
        url: `/projects/${projectId}/documentation${objectToQueryParams({
          filepath,
        })}`,
      }),
    onSuccess: (_, { projectId }) => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.getInstallationPlans(projectId),
      });
      queryClient.invalidateQueries({
        queryKey: queryKeys.getAsBuiltDocs(projectId),
      });
    },
  });

  const deleteProjectFile = useCallback((params: Params) => mutate(params), [mutate]);

  return {
    deleteProjectFile,
    error,
    isPending,
    isSuccess,
    reset,
  };
}
